/* eslint-disable consistent-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
import heic2any from "heic2any";
import api from "../components/api/api";

export const getImagesURL = async (paths, dis) => {
	if (!paths) {
		return
	}
	const urlPath = [];
	if (dis) paths = paths.split(dis);

	for (const ele of paths) {
		try {
			if (!ele.includes('.pdf')) {
				const { data } = await api.get(`/signedUrl?path=public/${ele}`);
				urlPath.push(data);
			}
		} catch (error) {
			console.log(error);
		}
	}

	return urlPath;
};

export const getImageSrc = async (path) => {
  if (!path) return [];

    try {
      if (!path.includes('.pdf')) {
        // Step 1: Get the presigned URL from your API
        const { data: presignedUrl } = await api.get(`/signedUrl?path=${path}`);
        // Step 2: Fetch the actual image using presigned URL
        const response = await fetch(presignedUrl);

        if (!response.ok) throw new Error('Failed to fetch image from presigned URL');

        // Step 3: Convert blob → object URL
        const blob = await response.blob();
		const isHeic = blob.type === 'image/heic' || blob.type === 'image/heif';
      if (isHeic) {
        const pngBlob = await heic2any({
          blob,
          toType: 'image/png',
          quality: 1
        });
        return URL.createObjectURL(pngBlob);
      }
        const imageUrl = URL.createObjectURL(blob);
	  	return imageUrl;
      }
    } catch (error) {
      console.error('Error fetching image:', error);
    }
  }

export async function processImageUrl(url) {
  try {
    const response = await fetch(url);
    const blob = await response.blob();

    const isHeic = blob.type === 'image/heic' || blob.type === 'image/heif';
    if (isHeic) {
      const pngBlob = await heic2any({
        blob,
        toType: 'image/png',
        quality: 1
      });
      return URL.createObjectURL(pngBlob);
    }
    return URL.createObjectURL(blob);
  } catch (err) {
    console.error('Error processing image:', url, err);
    return null; // or return a placeholder image URL
  }
}

